import { StyledCustomStepper } from "../../styled/Stepper";

const CustomStepper = ({ contador, maxGrupos, withStep }) => {

  return (
    <StyledCustomStepper.ProgressContainer>
      <StyledCustomStepper.LinearProgress
        variant="determinate"
        value={(contador / maxGrupos) * 100}
      />
      <StyledCustomStepper.DisplayGrupos>
        {withStep ? "Paso" : "Grupo"} {contador + 1} de {maxGrupos}
      </StyledCustomStepper.DisplayGrupos>
    </StyledCustomStepper.ProgressContainer>
  );
};

export default CustomStepper;
